import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = 'Loading...', size = 'medium' }) => {
  return (
    <div className={`loading-spinner loading-spinner--${size}`}>
      <div className="loading-spinner__container">
        <div className="loading-spinner__spinner"></div>
        {message && <p className="loading-spinner__message">{message}</p>}
      </div>
    </div>
  );
};

export default LoadingSpinner;
